import { Config } from '../../config'

export const testConfig: Config = {
  partner: 'test',
  catalog: 'partner',
  displayName: 'Testing Environment',
  accentColor: '#47538a',
  host: 'ecomseating.com',
}
